import * as React from 'react';
import Typography from '@material-ui/core/Typography';

export interface NotFoundProps {}

export default function NotFound(props: NotFoundProps) {
  return <Typography variant='display3'>Page Not found, Sorry!!</Typography>;
}
